/* ALUA × Holland & Barrett: photo upload form (sections/alua-hb-upload.liquid) */
(function () {
  function fmt(b) { return b > 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.round(b / 1024) + ' KB'; }

  function init(card) {
    if (!card || card.dataset.ahbReady) return;
    card.dataset.ahbReady = '1';

    var q = function (r) { return card.querySelector('[data-role="' + r + '"]'); };
    var form = q('form'), input = q('input'), drop = q('drop'), preview = q('preview'),
        thumb = q('thumb'), err = q('err'), done = q('done'), btn = q('submit');
    var d = card.dataset;
    var MAX = (parseInt(d.maxMb, 10) || 10) * 1024 * 1024;
    var submitLabel = btn.textContent;
    var file = null;

    function showErr(m) { err.textContent = m; err.classList.add('show'); }
    function clearErr() { err.classList.remove('show'); }

    function setFile(f) {
      clearErr();
      if (!f) return;
      var ok = /^image\/(jpeg|png|heic|heif)$/i.test(f.type) || /\.(jpe?g|png|heic|heif)$/i.test(f.name);
      if (!ok) { showErr(d.msgType); return; }
      if (f.size > MAX) { showErr(d.msgSize); return; }
      file = f;
      q('fname').textContent = f.name;
      q('fsize').textContent = fmt(f.size);
      thumb.removeAttribute('src');
      if (/jpe?g|png/i.test(f.type)) {
        var r = new FileReader();
        r.onload = function (e) { thumb.src = e.target.result; };
        r.readAsDataURL(f);
      }
      drop.style.display = 'none';
      preview.classList.add('show');
    }

    input.addEventListener('change', function () { setFile(input.files[0]); });
    q('replace').addEventListener('click', function () { input.value = ''; input.click(); });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files.length) setFile(e.dataTransfer.files[0]);
    });

    function success() {
      form.style.display = 'none';
      done.classList.add('show');
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function reset() { btn.disabled = false; btn.textContent = submitLabel; }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErr();
      if (!file) { showErr(d.msgPhoto); drop.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      var name = form.elements.fullname, email = form.elements.email;
      if (!name.value.trim()) { showErr(d.msgName); name.focus(); return; }
      if (!email.value.trim() || !email.checkValidity()) { showErr(d.msgEmail); email.focus(); return; }
      if (!form.elements.terms.checked) { showErr(d.msgTerms); return; }

      var endpoint = (d.endpoint || '').trim();
      btn.disabled = true;
      btn.textContent = d.msgUploading;

      if (!endpoint) {
        if (d.designMode === 'true') { setTimeout(success, 800); return; } // preview in theme editor
        console.warn('[ALUA H&B] No form endpoint set in the Upload form section.');
        reset(); showErr(d.msgSetup); return;
      }

      var data = new FormData();
      data.append('photo', file, file.name);
      data.append('fullname', name.value.trim());
      data.append('email', email.value.trim());
      data.append('terms', 'yes');
      data.append('campaign', d.campaign || '');
      data.append('page_url', window.location.href.split('?')[0]);
      data.append('submitted_at', new Date().toISOString());
      data.append('website', form.elements.website ? form.elements.website.value : '');

      fetch(endpoint, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (res.status === 409) { reset(); showErr(d.msgDuplicate || d.msgFailed); return; }
          if (!res.ok) throw new Error('HTTP ' + res.status);
          success();
        })
        .catch(function (ex) { console.error('[ALUA H&B] Upload failed', ex); reset(); showErr(d.msgFailed); });
    });
  }

  function initAll(root) { (root || document).querySelectorAll('[data-ahb-upload]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
